let tarjetasPath = "/TARJETAS/Socios/";
let tarjetasProcesosPath = "/TARJETAS/Procesos/";
let tarjetasContabilidadPath = "/TARJETAS/Contabilidad/";

let ProcessManager = function () {

    /**
     * Mapea a la proxima pantalla
     * @param {any} componenteActual
     * @param {any} accion
     */
    function _getNextStep(componenteActual, accion) {
        switch (componenteActual) {
            //switcheo por pantalla actual.
            case "ClientSearch":
                //switcheo por accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    case "ROUTE_TO_GESTION_CLIENTE":
                        return (tarjetasPath + "SOCIOS/Cliente");
                    default:
                        break;
                }
                break;

            case "VistaCliente":
                //switcheo por accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa");
                    case "ROUTE_TO_CUENTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/DatosCuenta");
                    case "ROUTE_TO_AVISO_VIAJE":
                        return (tarjetasPath + "SOCIOS/AvisoViaje");
                    default:
                        break;
                }
                break;

            case "NuevaSolicitudAdministradora":
                //switcheopor accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_TIPO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTipoEmpresa");
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    default:
                        return "";
                }
                break;

            case "NuevaSolicitudTipoEmpresa":
                //switcheopor accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa");
                    default:
                        return "";
                }
                break;
            case "NuevaSolicitudEmpresa":
                //switcheopor accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_NUEVA_EMPRESA":
                        return (tarjetasPath + "SOCIOS/Empresa");
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_TIPO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTipoEmpresa");
                    case "ROUTE_TO_CUENTA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudCuenta");
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    default:
                        break;
                }
                break;
            case "Empresa":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa");
                    default:
                        break;
                }
                break;

            case "Cuenta":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa");
                    case "ROUTE_TO_CUENTA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudCuenta");
                    default:
                        break;
                }
                break;

            case "ListadoProductos":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_NUEVO_PRODUCTO_LISTADO_PRODUCTO":
                        return (tarjetasPath + "LISTAPRODUCTOS/producto")
                    case "ROUTE_TO_EDITAR_PRODUCTO_LISTADO_PRODUCTO":
                        return (tarjetasPath + "LISTAPRODUCTOS/producto")
                    default:
                        return tarjetasPath;
                }
                break;
            case "NuevaSolicitudCuenta":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_NUEVA_CUENTA":
                        return (tarjetasPath + "SOCIOS/Cuenta");
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_TIPO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTipoEmpresa");
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa")
                    case "ROUTE_TO_TARJETA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTarjeta")
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    case "ROUTE_TO_NUEVA_SOLICITUD_ADICIONAL":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdicional");
                    default:
                        return tarjetasPath;
                }
                break;
            case "NuevaSolicitudAdicional":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_NUEVA_SOLICITUD_ADICIONAL":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdicional");
                    case "ROUTE_TO_DATOS_CUENTA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudCuenta");
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    default:
                        return tarjetasPath;
                }
                break;
            case "NuevaSolicitudTarjeta":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_TIPO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTipoEmpresa");
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa")
                    case "ROUTE_TO_CUENTA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudCuenta")
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    case "ROUTE_TO_CONFIRMACION":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudConfirmacion");
                    default:
                        return tarjetasPath;
                }
                break;

            case "NuevaSolicitudConfirmacion":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_ADMINISTRADORA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudAdministradora");
                    case "ROUTE_TO_TIPO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTipoEmpresa");
                    case "ROUTE_TO_EMPRESA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudEmpresa")
                    case "ROUTE_TO_CUENTA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudCuenta")
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                    case "ROUTE_TO_TARJETA":
                        return (tarjetasPath + "SOCIOS/NuevaSolicitudTarjeta")
                    default:
                        return tarjetasPath;
                }
                break;

            case "NuevaSolicitud":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_SELECCIONAR_CUENTA":
                        return (tarjetasPath + "SOCIOS/VistaCliente");
                        return tarjetasPath;
                }
                break;

            case "Producto":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_PRODUCTOS_PRODUCTO":
                        return (tarjetasPath + "LISTAPRODUCTOS/ListadoProductos")
                    default:
                        return tarjetasPath;
                }
                break;
            case "DatosCuenta":                
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_CLIENTE":
                        return (tarjetasPath + "SOCIOS/VistaCliente")
                    default:
                        return tarjetasPath;
                }
                break;

            case "EditarConfiguracionProcesos":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_EDITAR_CONFIGURACION_PROCESO":
                        return (tarjetasProcesosPath + "CONFIGPROCESOS/configuracionprocesos")
                    default:
                        return tarjetasProcesosPath;
                }
                break;
            case "ConfiguracionProcesos":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_CONFIGURACION_PROCESO":
                        return (tarjetasProcesosPath + "CONFIGPROCESOS/EditarConfiguracionProceso")
                    default:
                        return tarjetasProcesosPath;
                }
                break;
            
            case "ModelosContables":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_ABMMODELOS":
                        return (tarjetasContabilidadPath + "MODCONTABLE/ABMModelos")
                    case "ROUTE_TO_MODELOS_CONTABLES":
                        return (tarjetasContabilidadPath + "MODCONTABLE/ModelosContables")
                    default:
                        return tarjetasContabilidadPath;
                }
                break;

            default:
                return tarjetasPath;
                break;
        }
    }

    return {
        GetNextStep: function (componenteActual, accion, params) {
            return _getNextStep(componenteActual, accion, params);
        }
    }
}

let processManager = new ProcessManager();
export default processManager;